import { render } from "./PageNotFoundView.vue?vue&type=template&id=92ed7b96&scoped=true"
import script from "./PageNotFoundView.vue?vue&type=script&lang=js"
export * from "./PageNotFoundView.vue?vue&type=script&lang=js"

import "./PageNotFoundView.vue?vue&type=style&index=0&id=92ed7b96&scoped=true&lang=css"

import exportComponent from "/Users/alekseisemiguk/Documents/sadko/35FIT-full/35FIT/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-92ed7b96"]])

export default __exports__